//
//
//
//
//
//
export default {
  name: 'LineOnSideHeader'
};